var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.typeOptions,"track-by":"key","label":"value","multiple":false,"allowEmpty":false,"placeholder":"Tipo","selectedLabel":"","selectLabel":"","deselectLabel":""},on:{"input":_vm.notifyChange},model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}})
}
var staticRenderFns = []

export { render, staticRenderFns }